module.exports = __webpack_public_path__ + "static/speedo_white-e9177e1acbbe5552f32a1df55e80a6b6.png";